const PositionBannerTypeEnum = {
    LEFT: 1,
    RIGHT: 2
}
export default PositionBannerTypeEnum